export default __webpack_public_path__ + "assets/logo_login_modal.png";